// extracted by mini-css-extract-plugin
export default {"overlay":"Lw-z","bodyOpen":"Mw-z","content":"Nw-z","header":"Ow-z","close":"Pw-z","closeNoHeading":"Qw-z"};